'use client';

import { FC, ReactNode } from 'react';

import { isSSR } from '@telialt/utils/src/helpers';
import { useUserDataQueryBase } from '@telialt/utils/src/SSO/useUserData';
import { getIsUserAuthorized } from '@telialt/utils/src/SSO/utils';

import { ProductDetailsSkeleton } from '../ProductDetailsSkeleton/ProductDetailsSkeleton';

type Props = {
    children: ReactNode;
};

// ToDo: possible to combine (TranslationsInit, CartInitClientSide, UserDataInit) to single ProductPageInitializer
export const UserDataInit: FC<Props> = ({ children }) => {
    const { userData } = useUserDataQueryBase({ isEnabled: true });

    if (isSSR() || (!userData && getIsUserAuthorized())) {
        return <ProductDetailsSkeleton />;
    }

    return <>{children}</>;
};
